import { useMemo } from 'react';
import { TimeSlot } from '../../../state/infiniteCalendarSeries';
import { SESSION_SIZE } from '../types';
import {
    getDefaultActiveTab,
    getOverallDiscount,
    getSessionsByDurationAndTimeOfDay,
    getTabForSessionId,
    sortSessionsByStartTime,
} from './utils';

export const useTab = (
    timeSlotData: TimeSlot[],
    timezone: string,
    locale: string,
    isAppRebrandActive: boolean,
    selectedSessionId: string | undefined,
) => {
    const sortedTimeSlotSessions = useMemo(() => {
        if (timeSlotData?.length > SESSION_SIZE) {
            return sortSessionsByStartTime(timeSlotData);
        }
        return timeSlotData;
    }, [timeSlotData]);
    const { sessionsByDurationAndTimeOfDay } = useMemo(
        () =>
            getSessionsByDurationAndTimeOfDay({
                timeSlots: sortedTimeSlotSessions,
                timezone,
                locale,
                isAppRebrandActive,
            }),

        [sortedTimeSlotSessions, timezone, locale, isAppRebrandActive],
    );
    const defaultTab = getDefaultActiveTab(sessionsByDurationAndTimeOfDay);

    const activeTab = useMemo(() => {
        if (selectedSessionId && timeSlotData.length > SESSION_SIZE) {
            return getTabForSessionId(
                selectedSessionId,
                timeSlotData,
                timezone,
            );
        }
        return defaultTab;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSessionId]);
    return {
        overallDiscount: getOverallDiscount(timeSlotData),
        sessionsByDurationAndTimeOfDay,
        activeTab,
    };
};
